function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0.75 9.1845V10.9578C0.75 11.1212 0.878333 11.2495 1.04167 11.2495H2.815C2.89083 11.2495 2.96667 11.2203 3.01917 11.162L9.38917 4.79784L7.20167 2.61034L0.8375 8.9745C0.779167 9.03284 0.75 9.10284 0.75 9.1845ZM11.0808 3.10617C11.3083 2.87867 11.3083 2.51117 11.0808 2.28367L9.71583 0.918672C9.48833 0.691172 9.12083 0.691172 8.89333 0.918672L7.82583 1.98617L10.0133 4.17367L11.0808 3.10617Z"
});

const SvgEdit = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  fill: "#4F4F4F",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit.4a53212a.svg";
export { ForwardRef as ReactComponent };